import React from "react";
import "./AboutLottery.css";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import Participants from "../Participants/Participants";

const AboutLottery = () => {
  const location = useLocation();

  return (
    <>
      {location.pathname === "/about" && (
        <Helmet>
          <title>
            Vikinglotto: The Best Licensed Lottery with New Exciting Features
          </title>
          <meta
            name="description"
            content="Vikinglotto offers the best licensed lottery experience with new, exciting features. Join today for a chance to win big and enjoy secure, trusted gameplay!"
          />
          <link
            rel="canonical"
            href={`https://lottolegenda.com${location.pathname}`}
          />
        </Helmet>
      )}
      <main className="lottolegenda-main lottolegenda-results-page">
        <section className="lottolegenda-how__body pad pad-top flex">
          <h1>About Vikinglotto</h1>
          <p className="t-21 fw-700">Europe’s Original Transnational Lottery</p>
          <p>
            Vikinglotto was launched in 1993, making it the first international
            lottery game in Europe. Since then, it has united players from
            across the continent in the excitement of weekly draws and
            life-changing jackpots.
          </p>
        </section>
        <Participants />
        <section className="pad pad-top flex lottolegenda-legal">
          <h2>Legal Information</h2>
          <p>
            Vikinglotto is operated by the national lottery organizations of
            each participating country and is subject to local and EU
            regulations. Each national lottery partner is licensed, regulated,
            and audited according to strict government standards.
          </p>
          <p className="mg-bot  t-21">Key legal principles:</p>
          <ul>
            <li className=" t-21">Age restriction: Players must be 18+</li>
            <li className=" t-21">
              Ticket purchase and winnings are governed by the laws of the
              country of participation
            </li>
            <li className=" t-21">
              Winnings are tax-free in most participating countries
            </li>
          </ul>
        </section>
        <section className="pad pad-top flex lottolegenda-legal">
          <h2>Fairness & Transparency Standards</h2>
          <p className="mg-bot">
            Vikinglotto ensures full transparency, security, and fairness in
            every draw:
          </p>
          <ul>
            <li className=" t-21">
              Random Number Generators (RNGs) and physical ball machines are
              tested and certified
            </li>
            <li className=" t-21">
              All draws are supervised by independent auditors
            </li>
            <li className=" t-21">
              Prize allocation is published publicly after each draw
            </li>
            <li className=" t-21">
              Players can verify ticket results online or via national lottery
              apps
            </li>
          </ul>
          <p>
            Vikinglotto is committed to responsible gaming, data protection, and
            maintaining the trust of millions of players across Europe.
          </p>
        </section>
      </main>
    </>
  );
};

export default AboutLottery;
